import { Download } from "lucide-react";
import { useSelector } from "react-redux";

import CustomButton from "@/components/desktop/button/CustomButton";

import { useActivityExport } from "../hooks/useActivityExport";
import styles from "./settings-header.module.scss";

const SettingsHeader = () => {
	const { user } = useSelector((state) => state.auth);
	const { handleExport } = useActivityExport();

	if (!user?.superuser) return null;

	return (
		<div className={styles.header}>
			<CustomButton variant="secondary" size="sm" startIcon={<Download size={16} />} onClick={handleExport}>
				Exportar Actividad
			</CustomButton>
		</div>
	);
};

export default SettingsHeader;
